import { render, staticRenderFns } from "./EditPropertyCommunity.vue?vue&type=template&id=0bb9affc"
import script from "./EditPropertyCommunity.vue?vue&type=script&lang=js"
export * from "./EditPropertyCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports